import React, { Component } from 'react';

class RevContentComponent extends Component {

   constructor(props) {
    super(props);
    this.state = {objId: "rcjsload_" + new Date().getTime()};
  }

  componentDidMount() {
    // console.log("*** this.state.objId", this.state.objId);
    // console.log("*** this.props.clientId", this.props.clientId);

    var referer = "";
    try {
        referer = document.referrer;
        if ("undefined" == typeof referer || "" == referer) {
            throw new Error("undefined");
        }
    } catch (exception) {
        if (("" == referer || "undefined" == typeof referer) && (referer = document.URL)) {
            referer = document.location.href
        }
    }
    referer = referer.substr(0, 700);
    // console.log("*** referer", referer);

    var rcds = document.getElementById(this.state.objId);
    var rcel = document.createElement("script");
    rcel.id = 'rc_' + Math.floor(Math.random() * 1000);
    rcel.type = 'text/javascript';
    rcel.src = "https://trends.revcontent.com/serve.js.php?w="+this.props.clientId+"&t="+rcel.id+"&c="+(new Date()).getTime()+"&width="+(window.outerWidth || document.documentElement.clientWidth)+"&referer="+referer;
    // console.log("*** rcel.src", rcel.src);
    rcel.async = true;
    rcds.appendChild(rcel);

  }

  render(){

      var divStyle = {
               border: '0px'
      };

     return (
      <div className='RevContentComponent' style={divStyle} ref={el => (this.instance = el)}>
        <div id={this.state.objId} style={divStyle} ></div>
      </div>
    );
  }
}

export default RevContentComponent;



// WEBPACK FOOTER //
// ./app/components/ads/revContent.js